import React from "react";

const SvgBBiconsGrPomeroveUkazatele = props => (
  <svg data-name="Global report" viewBox="0 0 200 200" {...props}>
    <path
      d="M66.77 44.79a65.64 65.64 0 1097.45 57.42c0-2.15-.12-4.26-.32-6.35L100 109a2.25 2.25 0 01-.26 0 6.55 6.55 0 01-1.71.08h-.66a7.58 7.58 0 01-1.66-.51 5.8 5.8 0 01-.75-.46 8.28 8.28 0 01-.92-.67 7.27 7.27 0 01-.55-.56 6.35 6.35 0 01-.65-.87 8.45 8.45 0 01-.49-.82c0-.08-.1-.15-.14-.24zm31-12.64A71.93 71.93 0 0072 37l.19.46.27.65 21 49.76 2 4.66L97 96.27l1.21 2.8L146.36 51a71.51 71.51 0 00-48.6-18.82zm53.5 26.68L112 98.07l.51-.1 49-10.08 5.53-1.11A69.71 69.71 0 00157.75 67a72.73 72.73 0 00-6.49-8.17z"
      data-name="Pomerove ukazatele"
    />
  </svg>
);

export default SvgBBiconsGrPomeroveUkazatele;
